import React from 'react';

const warningIcon = (
    <i className="u-icon u-icon--sml u-icon--inactive u-mar--left--tny" style={{ flex: "0 0 auto" }}></i>
);

const truncateStyle = {
    flex: "1 1 auto",
    minWidth: 0,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
};

export const orderingDoctorItemRender = (li, itemProps) => {
    const doctor = itemProps && itemProps.dataItem;
    if (!doctor || doctor.pecosEnrollment) {
        return li;
    }

    const blockSelection = (e) => { e.preventDefault(); e.stopPropagation(); };
    const itemChildren = (
        <span className="opacity-50" style={{ display: "flex", alignItems: "center", width: "100%" }}>
            <span style={{ flex: "1" }}>{li.props.children}</span>
            {warningIcon}
        </span>
    );

    return React.cloneElement(li, {
        ...li.props,
        className: `${li.props.className || ""} is-disabled`,
        onClick: blockSelection,
        onMouseDown: blockSelection,
    }, itemChildren);
};

export const orderingDoctorValueRender = (element, value) => {
    if (!value) {
        return element;
    }

    if (value.pecosEnrollment) {
        return React.cloneElement(element, element.props,
            <span style={truncateStyle}>{element.props.children}</span>
        );
    }

    return React.cloneElement(element, element.props, [
        <span key="text" style={truncateStyle}>{element.props.children}</span>,
        warningIcon,
    ]);
};
